var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-progress-spinner',{class:{ 'spinner-lg': false },attrs:{"md-mode":"indeterminate","md-diameter":_vm.size * 9,"md-stroke":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }